/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from 'react-router-dom'
import { current } from "@reduxjs/toolkit"

function SliderEventi() {
    const navigate = useNavigate()
    const [eventi, setEventi] = useState({})
    const [currentIndex, setCurrentIndex] = useState(0)

    const d = new Date(); const meseNumber = d.getMonth()

    const nextSlide = () => {// Funzione per andare alla slide successiva
        const cvb = document.getElementsByClassName('slidetyu')
        for (let x = 0; x < cvb.length; x++) {
            cvb[x].style.transition = 'opacity 1.5s'; cvb[x].style.opacity = '0'
        }
        setTimeout(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === eventi.length - 1 ? 0 : prevIndex + 1
            )
            for (let x = 0; x < cvb.length; x++) {
                cvb[x].style.transition = 'opacity 1.5s'; cvb[x].style.opacity = '1'
            }
        }, 1000)
    }

    useEffect(() => {// useEffect per lo scorrimento automatico (AutoPlay) 
        const interval = setInterval(() => {
                nextSlide()
        }, 2000) // Cambia immagine ogni 2 secondi

        // Pulizia dell'intervallo per evitare memory leak
        return () => clearInterval(interval)
    }, [currentIndex])

    useEffect(() => {
        async function getEvent() {
            try {
                let response = await axios.get('/getEventi/dataFine')
                response.data.forEach(element => {
                   if (element.img) element.img = element.img.split(',')//da stringa ad array
                })
                setEventi(response.data
                    .filter(item => (item.accettazione !== 'rejection'))
                    .filter(item => (item.accettazione !== 'false'))
                    .filter(item => (new Date(item.dataFine).getMonth() >= (meseNumber - 1) && new Date(item.dataInizio).getMonth() <= (meseNumber + 5)))
                )
            } catch (err) { console.error(err) }
        }
        getEvent()
    }, [])

    // useEffect(() => { console.log('eventi:', eventi.length) }, [eventi])

    return (<>
        <div style={{ height: '530px' }} className="addImg">
            {eventi.length !== undefined &&
                <div style={{ background: 'linear-gradient(to right, #000000, #1c0463)', height: '300px', position: 'sticky', top: '0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', padding: '5px 0' }}>
                        <img src={`https://leuro-bucket.s3.amazonaws.com/locandina2_compress.webp`} style={{ width: '25%', transform: 'rotate(-15deg)', borderRadius: '50%' }} />

                        <div className="slidetyu text-center" style={{
                            color: 'beige', display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)', gap: '5px', flexGrow: '1'
                        }}>
                            <div className="mt-3" style={{ color: 'firebrick', fontSize: 'xx-large' }}>
                                <b>{eventi[currentIndex].titolo.charAt(0).toUpperCase() + eventi[currentIndex].titolo.slice(1).toLowerCase()}</b>
                            </div>

                            <div style={{ marginTop: '1em', fontSize: 'large' }}>
                                {eventi[currentIndex].dataInizio.substring(8, 10)}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '01' && ' Gennaio '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '02' && ' Febbraio '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '03' && ' Marzo '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '04' && ' Aprile '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '05' && ' Maggio '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '06' && ' Giugno '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '07' && ' Luglio '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '08' && ' Agosto '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '09' && ' Settembre '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '10' && ' Ottobre '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '11' && ' Novembre '}
                                {eventi[currentIndex].dataInizio.substring(5, 7) === '12' && ' Dicembre '}
                                {eventi[currentIndex].dataInizio.substring(0, 4)}
                            </div>
                            <div style={{ fontSize: 'x-large', color: 'lightgreen', marginTop: '1em' }}>
                                {eventi[currentIndex].città.toUpperCase()} ({eventi[currentIndex].provincia})
                                <span style={{ fontSize: 'medium', color: 'lawngreen', marginLeft: '10px' }}>
                                    {eventi[currentIndex].indirizzo}
                                </span>
                            </div>
                            <div style={{ transform: 'rotate(-5deg)', margin: '1em 0 0 0', color: 'gold', fontSize: 'x-large' }}>
                                {eventi[currentIndex].tipologia.toUpperCase()}
                            </div>
                        </div>

                        {eventi[currentIndex].img[0] ?
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${eventi[currentIndex].img[0]}`}
                                style={{ width: '25%', height: '280px', margin: '0 10px 0 0', objectFit: 'cover' }} className="slidetyu" />
                            : <img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`}
                                style={{ width: '25%', height: '280px', margin: '0 10px 0 0', objectFit: 'cover' }} />
                        }

                    </div>
                    <div style={{ height: '2.5em', backgroundColor: 'lightsteelblue', textAlign: 'center', paddingTop: '1px' }}>
                        <button className="btn w-25 fw-bold" onClick={() => { navigate('/fornitori') }}>Allestimenti</button>
                        <button className="btn ms-5 w-25 fw-bold" onClick={() => { navigate('/foodTruck') }}>Food-Truck</button>
                        <button className="btn ms-5 w-25 fw-bold" onClick={() => { navigate('/artisti') }}>Artisti</button>
                    </div>
                </div>
            }
        </div>
    </>)
}
export default SliderEventi